<script setup lang="ts">
import EstateListing from '~/components/estate/listing/EstateListing.vue'

const { t } = useI18n()

useHead({
  title: () => t('pages.estateListing.header.titles.seoOffice'),
  meta: [
    {
      name: 'title',
      content: t('pages.estateListing.header.titles.seoOffice'),
    },
    {
      name: 'description',
      content: t('pages.estateListing.header.descriptions.office'),
    },
  ],
})

useFancyHeader()

false && /*#__PURE__*/ defineI18nRoute({
  paths: {
    en: '/offices',
    sk: '/kancelarie',
  },
})
</script>

<template>
  <EstateListing estate-type="office" />
</template>
